import { cn } from "../../lib/cn.js";

/**
 * Placeholder de carga. Es lo que se muestra MIENTRAS se pide: no es un estado vacío ni
 * un cero. Cuando la respuesta llega vacía, va `EmptyState` (CLAUDE.md).
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "relative overflow-hidden rounded-[8px] bg-fill-2",
        "after:absolute after:inset-0 after:-translate-x-full after:bg-gradient-to-r after:from-transparent after:via-fill-3 after:to-transparent after:animate-[viva-shimmer_1.6s_infinite]",
        className,
      )}
    />
  );
}

/** Bloque de filas para tablas en carga. */
export function SkeletonRows({ rows = 6, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn("flex flex-col gap-2 p-3", className)} role="status" aria-label="Cargando">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-9 w-full" />
      ))}
    </div>
  );
}
